import React, { useEffect, useState, useContext } from "react";
import { FaWhatsapp } from "react-icons/fa";
import axios from "../axios";
import { Link, useNavigate } from "react-router-dom";
import "./Header.css";
import { FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import { AuthContext } from "./AuthContext";

const Header = () => {
  const navigate = useNavigate();
  const [logoUrl, setLogoUrl] = useState(null);
  const [pages, setPages] = useState([]);
  const [services, setServices] = useState({});
  const { isAuthenticated, logout } = useContext(AuthContext);

  // Mobile menu states
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [activeSubmenu, setActiveSubmenu] = useState(null);

  const handleLogout = () => {
    logout(); // already clears access_token, refresh_token, and user from localStorage
    navigate("/");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [logoResponse, pagesResponse, servicesResponse] =
          await Promise.all([
            axios.get(`${process.env.REACT_APP_API_URL}api/company-logo/`, {
              headers: { "Content-Type": "application/json" },
            }),
            axios.get(`${process.env.REACT_APP_API_URL}api/pages/`, {
              headers: { "Content-Type": "application/json" },
            }),
            axios.get(`${process.env.REACT_APP_API_URL}api/services/`, {
              headers: { "Content-Type": "application/json" },
            }),
          ]);

        console.log("Logo Response:", logoResponse.data);
        console.log("Pages Response:", pagesResponse.data);
        console.log("Services Response:", servicesResponse.data);

        if (logoResponse.data.length > 0) {
          const logoData = logoResponse.data.find(
            (item) => item.company_name === "logo_url"
          );
          const faviconData = logoResponse.data.find(
            (item) => item.company_name === "favicon_url"
          );

          console.log("Logo Data:", logoData);
          console.log("Favicon Data:", faviconData);

          if (logoData) {
            setLogoUrl(logoData.logo_url);
            console.log("Logo URL:", logoData.logo_url);
          }

          const favicon = document.querySelector("link[rel='icon']");
          const faviconUrl = faviconData ? faviconData.logo_url : null;
          if (faviconUrl) {
            console.log("Favicon URL:", faviconUrl);
            if (favicon) {
              favicon.href = faviconUrl;
            } else {
              const newFavicon = document.createElement("link");
              newFavicon.rel = "icon";
              newFavicon.href = faviconUrl;
              document.head.appendChild(newFavicon);
            }
          } else {
            console.warn("No favicon data found.");
          }
        } else {
          console.warn("No company logo data found.");
        }

        if (pagesResponse.data) {
          setPages(pagesResponse.data);
          console.log("Pages Data:", pagesResponse.data);
        } else {
          console.warn("No pages data found.");
        }

        const groupedServices = {};
        servicesResponse.data.forEach((service) => {
          if (!groupedServices[service.category]) {
            groupedServices[service.category] = [];
          }
          groupedServices[service.category].push(service);
        });

        setServices(groupedServices);
        console.log("Grouped Services:", groupedServices);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // Handle home click
  const handleHomeClick = (event) => {
    event.preventDefault();
    setIsMobileMenuOpen(false); // Close mobile menu
    navigate(isAuthenticated ? "/landing" : "/");
  };

  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    if (isMobileMenuOpen) {
      setActiveDropdown(null);
      setActiveSubmenu(null);
    }
  };

  // Close mobile menu when clicking overlay
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setActiveDropdown(null);
    setActiveSubmenu(null);
  };

  // Toggle dropdown in mobile
  const toggleDropdown = (e) => {
    e.preventDefault();
    setActiveDropdown(activeDropdown === 'services' ? null : 'services');
    setActiveSubmenu(null);
  };

  // Toggle submenu in mobile
  const toggleSubmenu = (category, e) => {
    e.stopPropagation();
    setActiveSubmenu(activeSubmenu === category ? null : category);
  };

  // Close menu when clicking a link
  const handleLinkClick = () => {
    setIsMobileMenuOpen(false);
    setActiveDropdown(null);
    setActiveSubmenu(null);
  };

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  return (
    <>
      {/* Mobile Menu Overlay */}
      <div
        className={`mobile-menu-overlay ${isMobileMenuOpen ? 'active' : ''}`}
        onClick={closeMobileMenu}
      />

      <header className="header">
        <div className="header-container">
          {/* Left Section - Logo */}
          <div className="header-left">
            <div className="logo-container">
              <a href="/" onClick={handleHomeClick}>
                {logoUrl ? (
                  <img src={logoUrl} alt="Logo" className="logo" />
                ) : (
                  <p>Loading Logo...</p>
                )}
              </a>
            </div>
          </div>

          {/* Hamburger Menu Button (Mobile Only) */}
          <button
            className={`hamburger-menu ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          {/* Right Section - Contact & Navigation */}
          <div className={`header-right ${isMobileMenuOpen ? 'mobile-menu-active' : ''}`}>
            {/* Contact Info */}
            <div className="contact-info">
              <a href="mailto:prabhu@my727infotech.co.in" onClick={handleLinkClick}>
                <FaEnvelope className="contact-icon" /> prabhu@my727infotech.co.in
              </a>
              <a href="tel:+919943007270" onClick={handleLinkClick}>
                <FaPhoneAlt className="contact-icon" /> +91 99430 07270
              </a>
              <a
                href="https://wa.me/919943007270?text=Hello%2C%20I%20would%20like%20to%20inquire%20about%20your%20services."
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleLinkClick}
              >
                <FaWhatsapp className="contact-icon" /> Chat on WhatsApp
              </a>
            </div>

            {/* Navigation Links */}
            <nav className="nav-links">
              <ul>
                <li>
                  <a href="/" onClick={handleHomeClick}>
                    Home
                  </a>
                </li>

                {/* Services Dropdown */}
                <li className={`dropdown ${activeDropdown === 'services' ? 'mobile-dropdown-active' : ''}`}>
                  <Link to="#" onClick={toggleDropdown}>
                    Services ▼
                  </Link>
                  <div className="dropdown-menu">
                    {Object.keys(services).map((category, index) => (
                      <div
                        key={index}
                        className={`dropdown-category ${activeSubmenu === category ? 'mobile-submenu-active' : ''}`}
                      >
                        <span
                          className="dropdown-category-title"
                          onClick={(e) => toggleSubmenu(category, e)}
                        >
                          {category} ➤
                        </span>
                        <div className="dropdown-submenu">
                          {services[category].map((service) => (
                            <Link
                              key={service.id}
                              to={`/services/${service.slug}`}
                              onClick={handleLinkClick}
                            >
                              {service.title}
                            </Link>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </li>

                {/* Pages Navigation */}
                {pages.map((page) => (
                  <li key={page.id}>
                    <Link to={`/pages/${page.slug}`} onClick={handleLinkClick}>
                      {page.title}
                    </Link>
                  </li>
                ))}

                {/* Login/Logout */}
                <li>
                  {isAuthenticated ? (
                    <Link to="/" onClick={(e) => { handleLogout(); handleLinkClick(); }} className="login-button">
                      Logout
                    </Link>
                  ) : (
                    <Link to="/login" className="login-button" onClick={handleLinkClick}>
                      Login
                    </Link>
                  )}
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;